import React from 'react';
import { array, object } from 'prop-types';

import m from 'moment';
import cx from 'classnames';

import s from './DetailMobileViewContainer.css';


const DetailMobileViewContainer = ({ ...props }) => {

  const ignoreClick = (event) => event.stopPropagation();

  const prettyPrintTime = (mintuesSinceMidnight) => {
    const hour = Math.floor(mintuesSinceMidnight / 60);
    const minute = mintuesSinceMidnight % 60;
    const hourStr = hour < 10 ? '0' + hour.toString() : hour.toString();
    const minuteStr = minute < 10 ? '0' + minute.toString() : minute.toString();
    return m(hourStr + minuteStr, 'Hm').format('h:mmA');
  };

  const prettyPrintDate = (date) => m(date, 'YYYY-MM-DD').format('dddd, MMM Do');

  const time = prettyPrintTime(props.appt.time);
  const date = prettyPrintDate(props.appt.date);

  const buttons = props.actions.map((button, index) =>
    <div key={index} className={s.buttonContainer}>
      <button className={cx(s.btn, {[`${s.cancel}`]: button.cancelButtonStyleRules})} onClick={button.action}>
        <span className={s.label}>{button.label}</span>
      </button>
    </div>
  );

  return (
    <section className={s.component} onClick={ignoreClick}>
      <div className={s.componentInner}>

        <div className={s.header}>
          <h1 className={s.primary}>{props.appt.type + ' with ' + props.appt.with}</h1>
          <h2 className={s.secondary}>{time + ' on ' + date}</h2>
          <h2 className={s.secondary}>{props.appt.location.name}</h2>
        </div>

        <div className={s.actions}>
          <div className={s.buttonRow}>
            {buttons}
          </div>
        </div>

      </div>
    </section>
  );

};

DetailMobileViewContainer.propTypes = {
  appt: object.isRequired,
  actions: array.isRequired
};

export default DetailMobileViewContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/DetailMobileView/DetailMobileViewContainer.js